module.exports = __webpack_public_path__ + "static/media/sr.5d004e8e.svg";